var callbacks = new Set();
export var updateDocumentTitleStatus = function (isHidden, saveStatus, mode, lastSavedTime, isSaveComplete) {
    var data = {
        isHidden: isHidden,
        saveStatus: saveStatus,
        mode: mode,
        lastSavedTime: lastSavedTime,
        isSaveComplete: isSaveComplete,
    };
    callbacks.forEach(function (callback) { return callback(data); });
};
export var registerDocumentTitleStatusChanged = function (callback) {
    if (previousData) {
        callback(previousData);
    }
    callbacks.add(callback);
    return callback;
};
export var unregisterDocumentTitleStatusChanged = function (callback) {
    return callbacks.delete(callback);
};
var previousData = undefined;
registerDocumentTitleStatusChanged(function (data) {
    previousData = data;
});
//# sourceMappingURL=updateDocumentTitleStatus.js.map